import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

export function getUserId(params) {
  return request({
    url: '/cmm/user/getUserId',
    method: 'post',
    data: params
  })
}

export function getUserGroup() {
  return request({
    url: '/cmm/user/getUserGroup',
    method: 'post'
  })
}
export function getUsers(params) {
  return request({
    url: '/cmm/user/getUsers',
    method: 'post',
    data: params
  })
}
export function getAllUsers(params) {
  return request({
    url: '/cmm/user/getAllUsers',
    method: 'post',
    data: params
  })
}
export function getUserDetail(params) {
  return request({
    url: '/cmm/user/getUserDetail',
    method: 'post',
    data: params
  })
}
export function setUserInfo(params) {
  return request({
    url: '/cmm/user/setUserInfo',
    method: 'post',
    data: params
  })
}

export function setPushToken(params) {
  return request({
    url: '/cmm/user/setPushToken',
    method: 'post',
    data: params
  })
}

export function getRegisterCheck(params) {
  return request({
    url: '/cmm/user/getRegisterCheck',
    method: 'post',
    data: params
  })
}

export function setPush(params) {
  return request({
    url: '/cmm/notification/setPush',
    method: 'post',
    data: params
  })
}

export function sendFCMPush(params) {
  return request({
    url: '/cmm/notification/sendFCMPush',
    method: 'post',
    data: params
  })
}
